/**
 * 自定义lodash中的部分方法
 */
// 防抖
import debounce from './debounce'
// 节流
import throttle from './throttle'
// 首字母大写
import upperFirst from './upperFirst'
export default {debounce, throttle, upperFirst}
